<script setup lang="ts">
defineOptions({
	name: 'IconCookies',
})

interface Props {
	class?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50 w-8 h-8',
})
</script>

<template>
	<svg
		:class="props.class"
		viewBox="0 0 57 57"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M19.0936 32.6318C18.9943 32.6315 18.8991 32.6712 18.8293 32.7418C18.7595 32.8125 18.7211 32.9082 18.7225 33.0075C18.7233 33.2146 18.8911 33.3824 19.0982 33.3832C19.2325 33.3823 19.356 33.3099 19.4224 33.1933C19.4888 33.0766 19.4879 32.9334 19.4201 32.8176C19.3523 32.7018 19.2278 32.6309 19.0936 32.6318"
			stroke="currentColor"
			stroke-width="3.47721"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M21.4295 21.0354C21.3302 21.0352 21.235 21.0749 21.1652 21.1455C21.0955 21.2162 21.057 21.3119 21.0585 21.4111C21.0592 21.6183 21.227 21.7861 21.4342 21.7868C21.6417 21.7856 21.8088 21.6163 21.8075 21.4088C21.8063 21.2013 21.637 21.0342 21.4295 21.0354"
			stroke="currentColor"
			stroke-width="3.47721"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M30.703 37.2692C30.6037 37.269 30.5084 37.3086 30.4387 37.3793C30.3689 37.4499 30.3304 37.5456 30.3319 37.6449C30.3327 37.8521 30.5004 38.0198 30.7076 38.0206C30.9151 38.0193 31.0823 37.8501 31.081 37.6426C31.0797 37.4351 30.9105 37.2679 30.703 37.2692"
			stroke="currentColor"
			stroke-width="3.47721"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M28.3866 27.9932C28.2873 27.993 28.192 28.0326 28.1223 28.1033C28.0525 28.1739 28.014 28.2696 28.0155 28.3689C28.0163 28.5761 28.184 28.7438 28.3912 28.7446C28.5254 28.7438 28.649 28.6714 28.7154 28.5547C28.7818 28.4381 28.7809 28.2949 28.7131 28.1791C28.6453 28.0632 28.5208 27.9924 28.3866 27.9932"
			stroke="currentColor"
			stroke-width="3.47721"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M28.3797 7.49731C28.3797 19.0246 37.7244 28.3692 49.2517 28.3692C49.2517 39.8965 39.907 49.2412 28.3797 49.2412C16.8525 49.2412 7.50781 39.8965 7.50781 28.3692C7.50781 16.842 16.8525 7.49731 28.3797 7.49731Z"
			stroke="currentColor"
			stroke-width="3.47721"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
